import { createConfirmation } from "react-confirm";
import AddExtraOptionDialog from "./AddExtraOptionDialog";

export const showAddExtraOptionDialog = createConfirmation(AddExtraOptionDialog);
